export { LandingPage as default } from "../src/modules/productDetail/components/ProductDetailLanding";
